// components/Composite/CodeBlock/CodeBlock.js
import PropTypes from 'prop-types';
import React, { useState } from 'react';

/**
 * CodeBlock - Syntax-highlighted code display composite
 * 
 * A StreamField content block for displaying code with syntax highlighting.
 * Wraps in Section primitive for consistent page spacing.
 * 
 * Backend data structure:
 * {
 *   language: string (e.g., "javascript", "python"),
 *   code: string (the actual code content)
 * }
 * 
 * Usage in StreamField:
 * Automatically rendered when type === 'code_block' or 'code'
 */

const CodeBlock = ({ value }) => {
  // Early return if no data
  if (!value || !value.code) {
    console.warn('CodeBlock: Missing required code data');
    return null;
  }

  const { language = 'text', code } = value;

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="">
      <div className="codeblock-container">
        {/* Language label header */}
        <div className="codeblock-header">
          <span>{language}</span>
          <button 
            onClick={handleCopy}
            className={`codeblock-copy-btn ${copied ? 'copied' : ''}`}
            aria-label="Copy code"
          >
            {copied ? '✓ Copied' : 'Copy'}
          </button>
        </div>
        
        {/* Code content */}
        <pre className="codeblock">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  );
};

CodeBlock.propTypes = {
  value: PropTypes.shape({
    language: PropTypes.string,
    code: PropTypes.string.isRequired,
  }).isRequired,
};

export default CodeBlock;